module.exports = __webpack_public_path__ + "static/media/the-craft.b633f5e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/the-craft.jpg
// module id = 269
// module chunks = 0